import { styled } from 'ds';
import { Text } from 'ds/components/typography';


export const InputWrapper = styled.div<{ hasError: boolean; }>`
  ${({ theme, hasError }) => `
    margin: 0 ${theme.spacing(1)};
    border: 1px solid ${hasError ? theme.colors.alert.red : theme.colors.brand.main};
    border-radius: ${theme.borderRadius.large};
    height: 48px;
    width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      outline: none;
      border: none;
      font-size: 25px;
      font-weight: 700;
      line-height: 32px;
      text-align: center;
      color: ${theme.colors.neutrals.grey1};

      ::focus {
        outline: none;
      }
    }
  `}
`;

export const CodeInputsWrapper = styled.div<{ hasBottomMargin: boolean; }>`
  ${({ theme, hasBottomMargin }) => `
    display: flex;
    justify-content: center;
  `}
`;

export const ErrorText = styled(Text)`
  ${({ theme }) => `
    text-align: center;
    direction: rtl;
    color: ${theme.colors.alert.red};
    margin-top: ${theme.spacing(1.5)};
  `}
`;

